<script>
  import { issues } from '../stores';
  import { onMount } from 'svelte';
  import { openFeedbackForm } from '../feedbackform';
  import { __ } from '../utils/i18n';
	
  onMount(() => {
    // set keyboard focus
    let firstFocus = document.querySelector('.flag-label a');
    firstFocus.focus();
    firstFocus.blur();

    document.documentElement.scrollTop = 0;
  });

  let buttons = [
    { id: 'voting', content: `✅ ${__("Voting")}` },
    { id: 'gardens', content: `🌿 ${__("Community gardens")}` },
    { id: 'police', content: `🚓 ${__("Police and crime")}` },
    { id: 'housing', content: `🏠 ${__("Housing and homelessness")}`},
  ];

  const toggleCheck = (i,e) => {
    if (e.key === "Enter") {
      e.target.click();
      let targetClass = e.target.getAttribute('class');
      let target;
      if (targetClass.includes('voting')){
        target = document.querySelector('label.pill.voting');
      } else if (targetClass.includes('police')){
        target = document.querySelector('label.pill.police');
      } else if (targetClass.includes('housing')) {
        target = document.querySelector('label.pill.housing');
      }
      (target.getAttribute("aria-pressed") == "false") ? target.setAttribute("aria-pressed", "true") : target.setAttribute("aria-pressed", "false");
    }
  }

</script>


  <p class="issue">{__("We’ll break down your local resources, representatives and institutions and help you get involved on your block. Select other topics you’d like to learn about.")}</p>
  <div class="issue-buttons" aria-label="{__('Select which issue or issues you’d like to explore.')}">
    {#each buttons as issue, i}
      <label
        tabindex="0" 
        class="pill {issue.id}" 
        class:checkedColor={$issues.includes(issue.id)}
        on:click={(e)=>toggleCheck(issue.id,e.target)}
        on:keypress={(e)=> toggleCheck(issue.id,e, this)}
        aria-pressed="false"
        role="button"
        >
        <input
          hidden
          type="checkbox"
          bind:group={$issues}
          value={issue.id}
          name="option-{issue.id}"
        />
        {issue.content}
      </label>
    {/each}
  </div>

  <p class="note-link">
    <a 
      aria-label="Open feedback form"
      class="feedback-special" href="#"
      on:click={(e)=>openFeedbackForm()}
      >{__("Want us to include other issues? Let us know!")}
    </a>
  </p>
